import { Caption, Group, SimpleCell, Text } from '@vkontakte/vkui';
import { Container } from '@mui/material';
import CardSlider from './CardSlider';
import { Link, Typography } from '@mui/joy';

function ResultView({ data, token }) {
    const items = data.items;

    if (items.length === 0) {
        return (
            <Text weight="2">
                Не удалось найти новомученников
            </Text>
        );
    }

    return (
        <Group>
            <SimpleCell>
                <Container className="container" maxWidth="xs">
                    <CardSlider
                        cards={items}
                        token={token}
                    />
                    <Caption
                        level="1"
                        weight="3"
                        style={{ textAlign: 'center', display: 'block', marginTop: 24, color: 'var(--vkui--color_text_secondary)' }}
                    >
                        © <a href="https://pstgu.ru" target="_blank" rel="noreferrer"
                            style={{ color: 'inherit', textDecoration: 'none' }}>ПСТГУ</a>.
                        База данных «За Христа пострадавшие»
                    </Caption>
                </Container>
            </SimpleCell>
        </Group>
    );
}

export default ResultView;
